// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-grid-link {
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
}

.users-popup .contentContainer {
  padding-top: 0;
  padding-bottom: 0;
  overflow-y: visible !important;
}

.users-popup .popupContainer {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Users/Users.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AACD;;AAEA;EACC,cAAA;EACA,iBAAA;EACA,8BAAA;AACD;;AAEA;EACC,4BAAA;AACD","sourcesContent":[".users-grid-link {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tmargin-left: 10px;\n\tfont-size: 12px;\n\tcursor: pointer;\n}\n\n.users-popup .contentContainer {\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n\toverflow-y: visible !important;\n}\n\n.users-popup .popupContainer {\n\toverflow: visible !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
